export const sortPlayersBySurname = ( a, b ) => a.player.surname > b.player.surname ? -1 : 1;